import { defaultCourseSection } from '@/components/elements/profile/enterprise/admin/data/section/defaultCourseSectionData';
import { defaultDegreeSection } from '@/components/elements/profile/enterprise/admin/data/section/defaultDegreeSectionData';
import { defaultHomepageSection } from '@/components/elements/profile/enterprise/admin/data/section/defaultHomepageSectionData';
import { defaultInformationSection } from '@/components/elements/profile/enterprise/admin/data/section/defaultInfomartionSectionData';
import { defaultMemberSection } from '@/components/elements/profile/enterprise/admin/data/section/defaultMemberSectionData';
import { defaultVideoSection } from '@/components/elements/profile/enterprise/admin/data/section/defaultVideoSectionData';
import {
  EEnterpriseTabKey,
  IEnterpriseProfileStructureJSON,
} from '../interfaces/enterprise-profile/enterprise.interface';

export const enterpriseTabName = {
  [EEnterpriseTabKey.HomePage]: 'Trang chủ',
  [EEnterpriseTabKey.Information]: 'Thông tin',
  [EEnterpriseTabKey.Member]: 'Thành viên',
  [EEnterpriseTabKey.Degree]: 'Bằng cấp',
  [EEnterpriseTabKey.Course]: 'Khoá học',
  [EEnterpriseTabKey.Video]: 'Video',
};

export const mock_enterprise: IEnterpriseProfileStructureJSON = {
  structure: [
    {
      tabName: enterpriseTabName[EEnterpriseTabKey.HomePage],
      tabKey: EEnterpriseTabKey.HomePage,
      isActive: true,
      sections: defaultHomepageSection,
    },
    {
      tabName: enterpriseTabName[EEnterpriseTabKey.Information],
      tabKey: EEnterpriseTabKey.Information,
      isActive: true,
      sections: defaultInformationSection,
    },
    {
      tabName: enterpriseTabName[EEnterpriseTabKey.Member],
      tabKey: EEnterpriseTabKey.Member,
      isActive: true,
      sections: defaultMemberSection,
    },
    {
      tabName: enterpriseTabName[EEnterpriseTabKey.Degree],
      tabKey: EEnterpriseTabKey.Degree,
      isActive: true,
      sections: defaultDegreeSection,
    },
    {
      tabName: enterpriseTabName[EEnterpriseTabKey.Course],
      tabKey: EEnterpriseTabKey.Course,
      isActive: true,
      sections: defaultCourseSection,
    },
    {
      tabName: enterpriseTabName[EEnterpriseTabKey.Video],
      tabKey: EEnterpriseTabKey.Video,
      isActive: true,
      sections: defaultVideoSection,
    },
  ],
};
